import React, { useContext } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../../contexts/AuthProvider/AuthProvider';
import useTitle from '../../hooks/useTittle';

const PostReview = () => {
    useTitle('Post Review');
    const { user } = useContext(AuthContext);
    console.log(user)
    const navigate = useNavigate();
    const food = useLoaderData()
    const handlePost = (event) => {
        event.preventDefault();
        const form = event.target;
        const name = form.name.value;
        const review = form.review.value;
        const email = user.email;
        const foodId = food._id;
        const avatar = user.photoURL;
        const rating = 5;
        const feedback = { name, review, email, foodId, avatar, rating };
        console.log(feedback);

        fetch('https://salma-kitchen-server.vercel.app/foods', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(feedback)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
            if(data.acknowledged){
                toast("Review Submitted");
                form.reset();
                navigate(`/food/${food._id}`)
                }
            })
    }

    return (
        <div className='bg-base-300 py-24'>
            <div className='flex justify-center'>
                <img className="w-64 mask mask-circle" src={food.image} alt="" />
            </div>
            <h1 className='text-3xl mb-6 text-center'>Post a review on {food.name}</h1>
            <form className='px-3' onSubmit={handlePost}>
                <div className="card sm:w-full md:w-2/5 bg-base-100 shadow-xl mx-auto p-6">
                    <div className="form-control w-full max-w-xs">
                        <label className="label">
                            <span className="label-text text-2xl">Your Name</span>
                        </label>
                        <input defaultValue={user.displayName} name='name' type="text" placeholder="Type here" className="input input-bordered w-full max-w-xs" />
                    </div>
                    <div className="form-control">
                        <label className="label">
                            <span className="label-text text-2xl">Your Review</span>
                        </label>
                        <textarea name='review' className="textarea textarea-bordered h-24" placeholder="Type your feedback here"></textarea>
                    </div>
                    <div className='mt-3'>
                        <button type='submit' className="w-full">Post</button>
                    </div>
                </div>

            </form>
        </div>
    );
};

export default PostReview;